import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import GmAboutHero from './components/About';
import Home from './components/Home';
import Navbar2 from './components/Navbar2';
import CareerHero from './components/CareerHero';
import ContactConversationPage from './components/ContactConversationPage';



function App() {
  return (
    <BrowserRouter>
      {/* <Navbar /> */}
      <Navbar2 />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<GmAboutHero />} />
        <Route path="/career" element={<CareerHero />} />
        <Route path="/contact-us" element={<ContactConversationPage />} />
        
      </Routes>

      <Footer />
    </BrowserRouter>



  );
}

export default App;
